var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricsDescr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54547 11.96H11.8182V13.8H4.54547V11.96Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54547 7.35999H15.4546V9.19998H4.54547V7.35999Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54547 16.5599H9.09093V18.3999H4.54547V16.5599Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 1.31059e-05H15.4545H14.5455H13.6364C13.6364 1.31059e-05 12.3004 0 11.8182 0L7.27273 1.31059e-05C6.79052 1.31059e-05 6.36364 1.31059e-05 6.36364 1.31059e-05H5.45455H4.54545H1.81818C1.33597 1.31059e-05 0.873508 0.19387 0.532533 0.538936C0.191558 0.884003 0 1.35201 0 1.84001V21.16C0 21.648 0.191558 22.116 0.532533 22.4611C0.873508 22.8061 1.33597 23 1.81818 23H18.1818C18.664 23 19.1265 22.8061 19.4675 22.4611C19.8084 22.116 20 21.648 20 21.16V1.84001C20 1.35201 19.8084 0.884003 19.4675 0.538936C19.1265 0.19387 18.664 1.31059e-05 18.1818 1.31059e-05ZM18.1818 21.16H1.81818V1.84001H4.54545H8.18182H11.3636H15.4545H18.1818V21.16Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsDescr);
export default __webpack_public_path__ + "static/media/metricsDescr.424affe255720e48b5d4fcc5caac6bed.svg";
export { ForwardRef as ReactComponent };